import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import logo from '../assets/svg/logo.svg';
import menu from '../assets/svg/menu.svg';

import list from '../assets/svg/list.svg';
import add from '../assets/svg/add.svg';
import rocket from '../assets/svg/rocket.svg';
import mail from '../assets/svg/mail.svg';
import settings from '../assets/svg/settings.svg';
import exit from '../assets/svg/exit.svg';
import edit from '../assets/svg/edit.svg';

import home from '../assets/svg/home.svg';

class Sidebar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _show: true
        };
    }




    render() {

        return (

            <div className={this.state._show ? `sidebar` : 'sidebar sidebar-hidden'}>
                <div className="top">
                    <div className="logo">
                        <Isvg src={logo} />
                    </div>

                </div>
                <div className="items">
                <h6>POČETNA</h6>
                    <ul>

                        <li>
                            <Link to='/' className={this.props[0].location.pathname == '/' ? 'active' : null}>
                                <Isvg src={home} />
                                Uredi
                            </Link>
                        </li>




                    </ul>
                    <h6>GALERIJA</h6>
                    <ul>

                        <li>
                            <Link to='/gallery' className={this.props[0].location.pathname == '/gallery' ? 'active' : null}>
                                <Isvg src={edit} />
                                Uredi
                            </Link>
                        </li>




                    </ul>

                    <h6>STRANICE</h6>
                    <ul>
                        <li>
                            <Link to='/collection/services' className={this.props[0].location.pathname == '/collection/services' ? 'active' : null}>
                                <Isvg src={list} />
                                Sve stranice
                            </Link>
                        </li>
                        <li>
                            <Link to='/collection/services/new' className={this.props[0].location.pathname == '/collection/services/new' ? 'active' : null}>
                                <Isvg src={add} />
                                Nova stranica
                            </Link>
                        </li>
                    </ul>
                   
                    <h6>BLOG</h6>
                    <ul>

                        <li>
                            <Link to='/collection/blog' className={this.props[0].location.pathname == '/collection/blog' ? 'active' : null}>
                                <Isvg src={list} />
                                Svi blogovi
                            </Link>
                        </li>


                        <li>
                            <Link to='/collection/blog/new' className={this.props[0].location.pathname == '/collection/blog/new' ? 'active' : null}>
                                <Isvg src={add} />
                                Novi blog
                            </Link>
                        </li>


                    </ul>

                   
                   <h6>INFORMACIJE</h6>
                    <ul>


                        <li>
                            <Link to='/information' className={this.props[0].location.pathname == '/information' ? 'active' : null}>
                                <Isvg src={edit} />
                                Uredi
                            </Link>
                        </li>


                    </ul>

                   {/* <h6>VIDEO SNIMCI</h6>
                    <ul>

                        <li>
                            <Link to='/collection/videos' className={this.props[0].location.pathname == '/collection/videos' ? 'active' : null}>
                                <Isvg src={list} />
                                Svi video snimci
                            </Link>
                        </li>


                        <li>
                            <Link to='/collection/videos/new' className={this.props[0].location.pathname == '/collection/videos/new' ? 'active' : null}>
                                <Isvg src={add} />
                                Novi video snimak
                            </Link>
                        </li>


                    </ul> */}
                    <h6>DOKUMENTI</h6>
                    <ul>

                        <li>
                            <Link to='/collection/documents' className={this.props[0].location.pathname == '/collection/documents' ? 'active' : null}>
                                <Isvg src={list} />
                                Svi dokumenti
                            </Link>
                        </li>


                        <li>
                            <Link to='/collection/documents/new' className={this.props[0].location.pathname == '/collection/documents/new' ? 'active' : null}>
                                <Isvg src={add} />
                                Novi dokument
                            </Link>
                        </li>


                    </ul>



                    <h6>KONTAKTI</h6>
                    <ul>
                        <li>
                            <Link to='/contacts' className={this.props[0].location.pathname == '/contacts' ? 'active' : null}>
                                <Isvg src={mail} />
                                Svi kontakti
                            </Link>
                        </li>

                    </ul>


                    <ul className="logout">
                        <li onClick={() => localStorage.removeItem('token')}>
                            <Link to='/login' >
                                <Isvg src={exit} />
                                Odjavi se
                            </Link>
                        </li>
                    </ul>

                </div>

                <div className="menu" onClick={() => this.setState({ _show: !this.state._show })}>
                    <Isvg src={menu} />
                </div>

            </div >
        )
    }

};

export default Sidebar;